import { AnalyticsBrowser } from '@segment/analytics-next';

// Initialize the analytics instance
export const analytics = new AnalyticsBrowser();

// Initialize with your write key
export const initializeAnalytics = () => {
  analytics.load({
    writeKey: process.env.REACT_APP_SEGMENT_API_KEY // You'll need to add this to your environment variables
  });
};

// Utility functions for tracking
export const trackEvent = (eventName, properties = {}) => {
  analytics.track(eventName, properties);
};

export const identifyUser = (userId, traits = {}) => {
  analytics.identify(userId, traits);
};

export const pageView = (name, properties = {}) => {
  analytics.page(name, properties);
};
